<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月22日 11:02:34 +0800
 * @最后修改时间: 2020-10-22 18:29:50
 * @FilePath: /mrc_ess_web_fronted/src/Page/EssAdmin/Roster/RosterFormRecord/components/TypeSelect.vue
 -->
<template>
  <div class="max-width pl-2">
    <div class="selectCycle grey lighten-4 text-start d-flex flex-row rounded-lg pa-1"
    :style="{width:allDay.length>7?'90px':'45px'}"
    >
      <v-card
        @click.stop="setCycleType(7)"
        :elevation="cycletype==7?2:0"
        :ripple="false"
        class="fill-height align-center d-flex text-center"
        :class="cycletype==7?'white rounded-lg':'transparent'"
        :style="{width:allDay.length>7?'50%':'100%'}"
      >
        <div class="flex-grow-1">7</div>
      </v-card>
      <v-card
        @click.stop="setCycleType(14)"
        v-if="allDay.length>7"
        :elevation="cycletype==14?2:0"
        :ripple="false"
        class="fill-height align-center d-flex text-center"
        :class="cycletype==14?'white rounded-lg':'transparent'"
        style="width:50%"
      >
        <div class="flex-grow-1">14</div>
      </v-card>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "TypeSelect",
  props: {
    cycletype: { default: 7, type: Number },
    allDay:{ default: [], type: Array },
  },

  data() {
    return {};
  },
  methods: {
    setCycleType: function (type) {
      this.$emit("change", type);
    },
  },
};
</script>
<style scoped>
.selectCycle {
  width:90px;
  height: 35px;
}
</style>